import { render, staticRenderFns } from "./FormDefault.vue?vue&type=template&id=06f9a68e&scoped=true&"
import script from "./FormDefault.vue?vue&type=script&lang=js&"
export * from "./FormDefault.vue?vue&type=script&lang=js&"
import style0 from "./FormDefault.vue?vue&type=style&index=0&id=06f9a68e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f9a68e",
  null
  
)

export default component.exports